<template>
  <router-view />
</template>

<style lang="scss">
html,body,#app{
height: 100%;
}
</style>
